import { Link, useLocation } from "react-router-dom";
import { useCart } from "../hooks/use-cart";
import { CartIcon } from "./site-icons";

function HomeIcon() {
  return (
    <svg aria-hidden="true" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="1.8">
      <path d="M4 11.5 12 5l8 6.5" />
      <path d="M6.5 10.8V20h4.8v-5.2h1.4V20h4.8v-9.2" />
    </svg>
  );
}

function ShopIcon() {
  return (
    <svg aria-hidden="true" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="1.8">
      <path d="M4 9.5h16l-1 10H5l-1-10Z" />
      <path d="M7 9.5a5 5 0 0 1 10 0" />
      <path d="M9.5 13h5" />
    </svg>
  );
}

const mobileLinks = [
  { label: "Home", to: "/", icon: HomeIcon },
  { label: "Shop", to: "/shop", icon: ShopIcon },
  { label: "Cart", to: "/shop/cart", icon: CartIcon }
];

export function MobileBottomNav() {
  const { cart } = useCart();
  const location = useLocation();
  const isShopActive =
    location.pathname === "/shop" ||
    location.pathname.startsWith("/shop/product") ||
    location.pathname.startsWith("/shop/categories") ||
    location.pathname === "/shop/search";
  const cartQuantity = cart?.summary.quantity || 0;

  return (
    <nav aria-label="Mobile primary navigation" className="mobile-bottom-nav md:hidden">
      <div className="section-shell">
        <div className="mobile-bottom-nav__shell">
          {mobileLinks.map((item) => {
            const Icon = item.icon;
            const isActive =
              item.to === "/"
                ? location.pathname === "/"
                : item.to === "/shop"
                    ? isShopActive
                    : location.pathname === "/shop/cart";

            return (
              <Link
                aria-current={isActive ? "page" : undefined}
                className={`mobile-bottom-nav__link${isActive ? " mobile-bottom-nav__link--active" : ""}`}
                key={item.to}
                to={item.to}
              >
                <Icon />
                <span className="mobile-bottom-nav__label">{item.label}</span>
                {item.to === "/shop/cart" && cartQuantity > 0 ? (
                  <span className="mobile-bottom-nav__badge">{cartQuantity}</span>
                ) : null}
              </Link>
            );
          })}
        </div>
      </div>
    </nav>
  );
}
